"use client";

import React from "react";

//Type
import { ImageUserNameProps } from "@/types";

//Styles
import * as S from "./styles";

//ImageDefault
import ImageUserDefault from "@/assets/images/image-default.png";

const ImageUserName: React.FC<ImageUserNameProps> = ({
  className,
  image,
  text,
  size,
}) => {
  return (
    <S.BoxUserName className={className}>
      <S.ImageUser src={image ? image : ImageUserDefault.src} $size={size} />
      <S.UserName>{text}</S.UserName>
    </S.BoxUserName>
  );
};

export default ImageUserName;
